import React, { useEffect } from "react";
import { TableHeaderColumn, BootstrapTable } from "/src/component/table/BootstrapTable";

import Loading from "../../../component/Loading";
import { dataTableConfig } from "../../../config/config";
import { VISIT_PAGE } from "../../../config/lang";

import { call } from "../../../util/action";
import { dateFormat } from "../../../util/formatter";
import { getStore } from "../../../util/redux/store";
import { translate } from "../../../util/util";

const me = getStore().getState().me;
function Orders({ data }) {
  const [state, setState] = React.useState({ orders: "", loading: false });
  const [orderList, setOrderList] = React.useState({});
  const [activeObj, setActiveObj] = React.useState({ isVisible: false, orderId: null });
  const extendedOptions = {
    ...dataTableConfig,
    onRowClick: order => getFetchOrderDetails(order),
  };

  useEffect(() => {
    setState(prev => ({ ...prev, loading: true }));
    let url = `visits/${data.id}/orders_in_visit/`;

    call({ method: "GET", url }, response => {
      setState(prev => ({
        ...prev,
        orders: response,
        loading: false,
      }));
    });
  }, [data.id]);

  const getDateChange = (item, obj) => {
    if (!item) return;

    let newDate = new Date(item);
    const date = dateFormat(newDate);
    return date;
  };

  const getTaskRowStatusClass = item => {
    if (!item.status) return;
    const str = item.status.toLowerCase();
    const result = str.replace(/ /g, "-");
    return result;
  };

  const getFetchOrderDetails = order => {
    setActiveObj(prev => ({ ...prev, isVisible: true }));

    if (orderList[order.id]) {
      showPopupOrder(orderList[order.id]);
      return;
    }

    let url = `excalibur/orders/${order.id}/`;
    call({ method: "GET", url }, response => {
      addOrUpdateOrder(response);
      showPopupOrder(response);
    });
  };

  const totalProductTableCalculate = () => {
    if (orderList[activeObj.orderId].items) {
      const total = orderList[activeObj.orderId].items.reduce((acc, item) => acc + (item.amount || 0) * item.quantity, 0);
      return total.toFixed(4);
    }
  };

  const addOrUpdateOrder = order => {
    setOrderList(prev => {
      if (prev[order.id]) return prev;

      return {
        ...prev,
        [order.id]: order,
      };
    });
  };

  const showPopupOrder = order => {
    if (!order) return;
    setActiveObj(prev => ({
      ...prev,
      orderId: order.id,
    }));
  };

  const prepareOrderFormat = item => {
    if (item === null || item === undefined) {
      return <span>-</span>;
    }
    return `<span>${item} грн.</span>`;
  };

  const getDataNameField = item => {
    if (!item) {
      return <span>-</span>;
    }
    return `<span>${item.name}</span>`;
  };

  const getItemStatus = (item, place = "list") => {
    if (!item) {
      return <span>-</span>;
    }
    const text = item.toLowerCase();
    const formattedLabelText = text.replaceAll("_", " ");
    const label =
      text === "new"
        ? "new"
        : text === "processing"
        ? "processing"
        : text.includes("delivering")
        ? "delivering"
        : text === "canceled"
        ? "canceled"
        : text === "closed"
        ? "closed"
        : "empty";

    if (place === "popup") {
      return `order-popup-item-label-${label}`;
    } else {
      return `<span class="orders-task-status-label orders-task-status-label-${label}">${formattedLabelText}</span>`;
    }
  };

  const getDataNameFieldTable = item => {
    if (!item) {
      return <span>-</span>;
    }
    return `<span class="orders-task-popup-item-name">${item.name}</span>`;
  };

  const preparePopupOrderTotal = (item, obj) => {
    if (!obj) {
      return <span>-</span>;
    }
    const total = obj.amount * obj.quantity;
    total.toFixed(4);

    return `<span class="orders-task-popup-item-name">${total} ${translate(VISIT_PAGE, "orders_currency_total", me.language)}</span>`;
  };

  const handleClose = () => {
    setActiveObj(prev => ({
      ...prev,
      isVisible: false,
    }));
  };

  return (
    <>
      <div className="orders-task-tab-wrapper">
        {state?.orders ? (
          <>
            <BootstrapTable
              data={state.orders}
              version="4"
              striped
              hover
              bordered={false}
              pagination={false}
              search={false}
              multiColumnSearch={true}
              columnFilter={false}
              options={extendedOptions}
              className="themed-main-table-container"
              trClassName={row => `orders-task-tab-item ${getTaskRowStatusClass(row)}`}
              tableHeaderClass="primary">
              <TableHeaderColumn dataField="name" isKey width="60px">
                {translate(VISIT_PAGE, "orders_product_name", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getDataNameField} dataField="counterparty" width="60px">
                {translate(VISIT_PAGE, "orders_popup_counterparty_label", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={(item, obj) => getDateChange(item, obj)} dataField="datetime" width="60px">
                {translate(VISIT_PAGE, "orders_product_status_date", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={getItemStatus} dataField="status" width="60px">
                {translate(VISIT_PAGE, "orders_product_status", me.language)}
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={(item, obj) => prepareOrderFormat(item, obj)} dataField="order_total" width="60px">
                {translate(VISIT_PAGE, "orders_product_total", me.language)}
              </TableHeaderColumn>
            </BootstrapTable>
          </>
        ) : (
          <Loading loading={state.loading} />
        )}
        <div className={`popup-item-order-wrapper ${activeObj.isVisible ? "is-active" : ""}`}>
          {activeObj.isVisible && orderList[activeObj.orderId] ? (
            <div className="popup-item-order">
              <div className="close-order-popup" onClick={handleClose}></div>
              <div className="order-popup-header">
                <h3>
                  {translate(VISIT_PAGE, "orders_popup_order_id_title", me.language)}: <span>{orderList[activeObj.orderId].id}</span>
                </h3>
                <p className="order-sub-title">{translate(VISIT_PAGE, "orders_popup_details_title", me.language)}</p>
              </div>
              <div className="order-popup-content-wrapper">
                <div className="order-popup-content">
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_sales_rep_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].created_by?.first_name ? orderList[activeObj.orderId].created_by.first_name : ""}{" "}
                      {orderList[activeObj.orderId].created_by?.last_name ? orderList[activeObj.orderId].created_by.last_name : ""}
                      {!orderList[activeObj.orderId].created_by?.first_name && !orderList[activeObj.orderId].created_by?.last_name ? "-" : ""}
                    </span>
                  </div>
                  <div className="order-popup-content-item  order-popup-created-by">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_order_status_label", me.language)}</span>
                    <span className={`order-popup-content-item-value ${getItemStatus(orderList[activeObj.orderId].status, "popup")}`}>
                      {orderList[activeObj.orderId].status ? orderList[activeObj.orderId].status : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_counterparty_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].counterparty?.name ? orderList[activeObj.orderId].counterparty?.name : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_created_time_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].datetime ? getDateChange(orderList[activeObj.orderId].datetime) : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_order_type_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].order_type?.name ? orderList[activeObj.orderId].order_type?.name : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_delivery_time_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].delivery_date ? getDateChange(orderList[activeObj.orderId].delivery_date) : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_tracked_geolocation_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].tracked_geolocation.latitude && orderList[activeObj.orderId].tracked_geolocation.longitude ? (
                        <>
                          <span className="order-popup-content-value-color">lat:</span> {orderList[activeObj.orderId].tracked_geolocation.latitude}
                          <br />
                          <span className="order-popup-content-value-color">lng:</span> {orderList[activeObj.orderId].tracked_geolocation.longitude}
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_custom_fields_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].custom_fields ? orderList[activeObj.orderId].custom_fields : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_comment_label", me.language)}</span>
                    <span className="order-popup-content-item-value">
                      {orderList[activeObj.orderId].comments ? orderList[activeObj.orderId].comments : "-"}
                    </span>
                  </div>
                  <div className="order-popup-content-item">
                    <span className="order-popup-content-item-label">{translate(VISIT_PAGE, "orders_popup_visit_label", me.language)}</span>
                    <span className="order-popup-content-item-value">{orderList[activeObj.orderId].visit ? orderList[activeObj.orderId].visit : "-"}</span>
                  </div>
                  {orderList[activeObj.orderId]?.items && orderList[activeObj.orderId].items?.length > 0 && (
                    <div className="order-popup-content-item full-cell">
                      <span className="order-popup-content-item-value">{translate(VISIT_PAGE, "orders_popup_order_table_label", me.language)}</span>
                      <BootstrapTable
                        data={orderList[activeObj.orderId].items}
                        version="4"
                        striped
                        hover
                        bordered={false}
                        pagination={false}
                        search={false}
                        multiColumnSearch={true}
                        columnFilter={false}
                        options={{ ...dataTableConfig }}
                        className="themed-main-table-container"
                        trClassName={row => `orders-task-tab-item orders-popup-table-item-row`}
                        tableHeaderClass="primary">
                        <TableHeaderColumn dataFormat={getDataNameFieldTable} isKey={true} dataField="product" width="60">
                          {translate(VISIT_PAGE, "orders_popup_order_table_name", me.language)}
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="quantity" width="60px">
                          {translate(VISIT_PAGE, "orders_popup_order_table_quantity", me.language)}
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="amount" width="60px">
                          {translate(VISIT_PAGE, "orders_popup_order_table_amount", me.language)}
                        </TableHeaderColumn>
                        <TableHeaderColumn dataFormat={(item, obj) => preparePopupOrderTotal(item, obj)} dataField="amount" width="60px">
                          {translate(VISIT_PAGE, "orders_product_total", me.language)}
                        </TableHeaderColumn>
                      </BootstrapTable>
                      <div className="orders-task-tab-item custom-total-cell">
                        <span className="custom-total-cell-title">{translate(VISIT_PAGE, "orders_product_total", me.language)}:</span>
                        <span className="custom-total-cell-last">
                          {totalProductTableCalculate()} {translate(VISIT_PAGE, "orders_currency_total", me.language)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          <div className={`order-popup-overlay ${activeObj.isVisible ? "is-active" : ""}`} onClick={handleClose}></div>
        </div>
      </div>
    </>
  );
}

export default Orders;